<template>
    <el-row :gutter="20">
        <el-col :span="3">
            <div class="input-card-style">
                <label>
                    <input
                    type="radio"
                    name="customer"
                    checked
                    class="card-input-element"
                    @click="setShipFlowMode(1)"
                    >
                    <div class="card-input text-center ship-panel-box">
                        <div>
                            <span class="ship-panel-font">{{shipflowPanelInfo.allPickupTomorrow}}<i class="el-icon-top shipflow-arrow-icon-teal"></i></span><br>
                            <span class="ship-panel-sub-font">เข้ารับพรุ่งนี้</span>

                        </div>
                    </div>
                </label>
            </div>
        </el-col>
        <el-col :span="2">
            <el-row type="flex" align="middle" justify="center" class="shipflow-card-style">
                <el-col >
                <i class="el-icon-right shipflow-arrow-icon"></i>
                </el-col>
            </el-row>
        </el-col>
        <el-col :span="3">
            <div class="input-card-style">
                <label>
                    <input
                    type="radio"
                    name="customer"
                    class="card-input-element"
                    @click="setShipFlowMode(2)"
                    >
                    <div class="card-input text-center ship-panel-box">
                        <div>
                            <span class="ship-panel-font">{{shipflowPanelInfo.allPickupToday}}</span><br>
                            <span class="ship-panel-sub-font">เข้ารับวันนี้</span>
                        </div>
                    </div>
                </label>
            </div>
        </el-col>
        <el-col :span="2">
            <el-row type="flex" align="middle" justify="center" class="shipflow-card-style">
                <el-col>
                <i class="el-icon-right shipflow-arrow-icon"></i>
                </el-col>
            </el-row>
        </el-col>
        <el-col :span="3">
            <div class="input-card-style">
                <label>
                    <input
                    type="radio"
                    name="customer"
                    class="card-input-element"
                    @click="setShipFlowMode(3)"
                    >
                    <div class="card-input text-center ship-panel-box">
                        <div>
                            <span class="ship-panel-font">{{shipflowPanelInfo.allConfirmed}}</span><br>
                            <span class="ship-panel-sub-font">Confirm แล้ว</span>
                        </div>
                    </div>
                </label>
            </div>
        </el-col>
        <el-col :span="2">
            <el-row type="flex" justify="center">
                <el-col :span="2">
                    <el-card class="shipflow-card-style shipflow-card-never"  shadow="never">
                    </el-card>
                </el-col>
            </el-row>
        </el-col>

        <el-col :span="3">
            <div class="input-card-style">
                <label>
                    <input
                    type="radio"
                    name="customer"
                    class="card-input-element"
                    @click="setShipFlowMode(4)"
                    >
                    <div class="card-input text-center ship-panel-box">
                        <div>
                            <span class="ship-panel-font">{{shipflowPanelInfo.allWaitForPickup}}<i class="el-icon-bottom shipflow-arrow-icon-teal"></i></span><br>
                            <span class="ship-panel-sub-font">รอเข้ารับ</span>
                        </div>
                    </div>
                </label>
            </div>
        </el-col>
        <el-col :span="3">
            <div class="input-card-style">
                <label>
                    <input
                    type="radio"
                    name="customer"
                    class="card-input-element"
                    @click="setShipFlowMode(5)"
                    >
                    <div class="card-input text-center ship-panel-box">
                        <div>
                            <span class="ship-panel-font">{{shipflowPanelInfo.allPickedUp}}<i class="el-icon-top shipflow-arrow-icon-teal"></i></span><br>
                            <span class="ship-panel-sub-font">รถเข้ารับแล้ว</span>
                        </div>
                    </div>
                </label>
            </div>
        </el-col>
        <el-col :span="3">
            <el-row type="flex" align="middle" justify="center" class="shipflow-card-style" >
                <el-col >
                    <el-switch
                        v-model="autoConfirm"
                        :disabled="true">
                    </el-switch>
                    <div>
                        <span class="auto-confirm-label">Auto-Confirm</span>
                    </div>
                </el-col>
            </el-row>
        </el-col>

    </el-row>
</template>

<script>
export default {
    name: 'ShipFlowPanel',
    props: {
        shipflowMode: {
            type: Object,
            default: () => {
                return {
                    mode: 1
                }
            }
        },
        shipflowPanelInfo: {
            type: Object,
            default: () => {
                return {
                    allPickupTomorrow: 0,
                    allPickupToday: 0,
                    allConfirmed: 0,
                    allWaitForPickup: 0,
                    allPickedUp: 0
                }
            }
        }
    },
    data () {
        return {
            autoConfirm: false
        }
    },
    methods: {
        setShipFlowMode (mode) {
            this.shipflowMode.mode = mode
        }
    }
}
</script>
<style lang="scss" scoped>
    .shipflow-card-style {
        min-height: 84px;
        .justify-arrow{
            justify-content: center;
        }
        i.shipflow-arrow-icon{
            font-size: 22px;
            font-weight: 700;
        }
    }
    .shipflow-btn-switch {
        padding: 7% 10px;
    }
    .shipflow-card-never{
        max-width: 0px;
    }
    .ship-panel-box{
        padding: 20px 0px;
        .ship-panel-font{
            font-size: 16px;
            font-weight: 500;
        }
        .ship-panel-sub-font{
            font-size: 14px;
            font-weight: 300;
        }
    }
    .input-card-style {
        font-family: 'Sarabun', sans-serif;
        border: 2px solid rgba(237, 239, 240, 0.664);
        border-radius: 2px;
        max-width: 135px;
        width: 100%;
        height: 84px;
        i.shipflow-arrow-icon-teal{
            font-size: 16px;
            font-weight: 700;
            color: #08A7A3;
        }
    }
    .card-input-element {
        display: none;
        border: 1px solid #0000;
    }
    .card-input-element:checked + .card-input {
        border: 2px solid rgba($color: #08A7A3, $alpha: 1.0);
        // background-color: rgba($color: teal, $alpha: 1.0);
        border-radius: 2px;
        color: black;
        height: 84px;
    }
    .card-input:hover {
        cursor: pointer;
    }
    .auto-confirm-label{
        font-family: 'Sarabun', sans-serif;
        font-size: 12px;
        color: #676767;
    }
</style>
